import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Module, Right} from '../../models/models';
import {LoginService} from '../../services/login.service';
import {CheckService} from '../../services/check.service';

@Component({
  selector: 'app-damage-administration',
  templateUrl: './damage-administration.component.html',
  styleUrls: ['./damage-administration.component.css']
})
export class DamageAdministrationComponent implements OnInit {

  public damageAdministrationRecordModule: Module;
  public damageAdministrationCaseModule: Module;
  public damageAdministrationCoreDataModule: Module;
  public damageAdministrationOverviewModule: Module;
  public damageAdministrationCaseOverviewModule: Module;
  public damageAdministrationReportModule: Module;
  public damageAdministrationEvaluationModule: Module;
  public damageAdministrationLogModule: Module;
  public rights: Right[];

  constructor(private router: Router, private loginService: LoginService, private checkService: CheckService) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkModule(60);
    this.rights = JSON.parse(sessionStorage.getItem('Rights'));

    this.rights.forEach(right => {
      switch (right.RightId) {
        case 8:
          this.damageAdministrationRecordModule = new Module();
          this.damageAdministrationRecordModule.ModuleName = 'Schäden verwalten';
          this.damageAdministrationRecordModule.ModuleDesc = '';
          this.damageAdministrationRecordModule.ModuleButtonText = 'Los';
          this.damageAdministrationRecordModule.ForwardLink = '/damageAdministrationRecord';

          this.damageAdministrationCaseModule = new Module();
          this.damageAdministrationCaseModule.ModuleName = 'Schäden verwalten (Neu)';
          this.damageAdministrationCaseModule.ModuleDesc = '';
          this.damageAdministrationCaseModule.ModuleButtonText = 'Los';
          this.damageAdministrationCaseModule.ForwardLink = '/damageAdministrationCase';
          break;
        case 9:
          this.damageAdministrationCoreDataModule = new Module();
          this.damageAdministrationCoreDataModule.ModuleName = 'Stammdaten verwalten';
          this.damageAdministrationCoreDataModule.ModuleDesc = '';
          this.damageAdministrationCoreDataModule.ModuleButtonText = 'Los';
          this.damageAdministrationCoreDataModule.ForwardLink = '/damageAdministrationCoreData';
          break;
        case 12:
          this.damageAdministrationReportModule = new Module();
          this.damageAdministrationReportModule.ModuleName = 'Schadenmeldungen';
          this.damageAdministrationReportModule.ModuleDesc = '';
          this.damageAdministrationReportModule.ModuleButtonText = 'Los';
          this.damageAdministrationReportModule.ForwardLink = '/damageAdministrationReport';
          
          this.damageAdministrationOverviewModule = new Module();
          this.damageAdministrationOverviewModule.ModuleName = 'Schäden Übersicht';
          this.damageAdministrationOverviewModule.ModuleDesc = '';
          this.damageAdministrationOverviewModule.ModuleButtonText = 'Los';
          this.damageAdministrationOverviewModule.ForwardLink = '/damageAdministrationOverview';

          this.damageAdministrationCaseOverviewModule = new Module();
          this.damageAdministrationCaseOverviewModule.ModuleName = 'Schäden Übersicht (Neu)';
          this.damageAdministrationCaseOverviewModule.ModuleDesc = '';
          this.damageAdministrationCaseOverviewModule.ModuleButtonText = 'Los';
          this.damageAdministrationCaseOverviewModule.ForwardLink = '/damageAdministrationCaseOverview';
          break;
        case 13:
          this.damageAdministrationEvaluationModule = new Module();
          this.damageAdministrationEvaluationModule.ModuleName = 'Auswertungen';
          this.damageAdministrationEvaluationModule.ModuleDesc = '';
          this.damageAdministrationEvaluationModule.ModuleButtonText = 'Los';
          this.damageAdministrationEvaluationModule.ForwardLink = '/damageAdministrationEvaluation';
          break;
        case 14:
          this.damageAdministrationLogModule = new Module();
          this.damageAdministrationLogModule.ModuleName = 'Logs';
          this.damageAdministrationLogModule.ModuleDesc = '';
          this.damageAdministrationLogModule.ModuleButtonText = 'Los';
          this.damageAdministrationLogModule.ForwardLink = '/damageAdministrationLogs';
          break;
      }
    });
  }

  navigate(forwardLink: string) {
    this.router.navigate([forwardLink]);
  }
}
